<div *ngIf="!loading">
    <div *ngIf="feedback; else endgame">
        <div *ngIf="!feedback_submitted; else submitted" class="feedback-container">
            <h1 class="center-text lg-mt">How did {{feedback_targets[0].name}} do?</h1>
            <div>
                <span *ngFor="let star of stars"
                    class="star"
                    [class.filled]="star <= feedback.stars"
                    (click)="selectRating(star)">
                    &#9733; <!-- Unicode star character or Font Awesome icon -->
                </span>
            </div>
            <div *ngIf="feedback.stars">
                <h2 class="center-text">{{feedback.stars > 3 ? 'What did they do well?' : 'What could they improve?'}}</h2>
                <div class="tag-container">
                    <div 
                        class="tag" 
                        [class.selected]="feedback.tags.includes(tag)" 
                        *ngFor="let tag of available_tags" 
                        (click)="toggleTag(tag)">
                        {{tag}}{{tag === 'Other' ? ' (Describe Below)' : ''}}
                    </div>
                </div>
                
            </div>
            <textarea *ngIf="feedback.stars" class="notes-textarea" placeholder="Anything else we should know?" [(ngModel)]="feedback.notes"></textarea>
            <button *ngIf="feedback.stars" (click)="submitFeedback()">Submit</button>
        </div>
    </div>
    
    <p class="error-message" *ngIf="err">{{err}}</p>
</div>

<ng-template #submitted>
    <h1 class="round-message">Thank you for your feedback!</h1>
</ng-template>

<ng-template #endgame>
    <div *ngIf="game.status === 'ended' || game.status === 'finalized'">
        <h2 class="round-message">The game has ended. Thanks for playing!</h2>
    </div>
</ng-template>
